<template>
  <div class="price-grids">
    <div v-for="group in groups" :key="group.code" class="price-grids__grid">
      <div class="price-grids__grid-label" v-if="groups.length > 1 || showSingleLabel">
        {{ group.label }}
      </div>
      <dl class="price-grids__list">
        <div
          v-for="price in group.prices"
          :key="price.id"
          class="price-grids__row"
          :class="{
            'price-grids__row--last': price.is_last,
            'price-grids__row--active': isActive(group, price),
          }"
        >
          <dt class="price-grids__range">{{ price.label }}</dt>
          <dd class="price-grids__value">
            <strong>{{ formatValue(price.price_value) }}&nbsp;€</strong> / jour
          </dd>
        </div>
      </dl>
    </div>
    <div v-if="!groups.length" class="price-grids__empty">Aucun tarif renseigné</div>
  </div>
</template>

<script>
export default {
  name: "PriceGrids",
  props: {
    // Prix bruts du produit, tels que renvoyés par l'API
    prices: {
      type: Array,
      default: () => [],
    },
    // Affiche le nom de la grille même s'il n'y en a qu'une
    showSingleLabel: {
      type: Boolean,
      default: false,
    },
    // Palier en cours à mettre en avant (ex. celui facturé à une référence)
    activeRange: {
      type: String,
      default: null,
    },
    // Grille à laquelle se rapporte activeRange. Le palier courant d'une référence
    // est calculé sur les seuils Axiloc (ReferenceManager::getReferenceCurrentPrice) :
    // le mettre en avant dans la grille ESM induirait en erreur.
    activeGrid: {
      type: String,
      default: "axiloc",
    },
  },
  computed: {
    groups() {
      return this.$store.getters["product/getPriceGroups"](this.prices);
    },
  },
  methods: {
    isActive(group, price) {
      return (
        !!this.activeRange &&
        group.code == this.activeGrid &&
        price.price_range == this.activeRange
      );
    },
    formatValue(value) {
      const parsed = parseFloat(value);

      return isNaN(parsed) ? "-" : parsed.toFixed(2).replace(".", ",");
    },
  },
};
</script>

<style lang="scss" scoped>
.price-grids {
  // Les grilles côte à côte : on compare ESM et Axiloc d'un coup d'œil.
  display: flex;
  flex-wrap: wrap;
  gap: 12px 32px;
  // Largeurs strictement égales, quel que soit le contenu des libellés.
  &__grid {
    flex: 1 1 0;
    min-width: 0;
  }
  &__grid + &__grid {
    padding-left: 32px;
    border-left: 1px solid #e9e9e9;
  }
  // Écrans étroits : les grilles repassent l'une sous l'autre, le filet vertical
  // n'a plus de sens.
  @media (max-width: 991px) {
    &__grid {
      flex-basis: 100%;
    }
    &__grid + &__grid {
      padding-left: 0;
      padding-top: 12px;
      border-left: none;
      border-top: 1px solid #e9e9e9;
    }
  }
  &__grid-label {
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.04em;
    color: #9a9a9a;
    margin-bottom: 6px;
  }
  &__list {
    margin: 0;
  }
  &__row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    padding: 3px 0;
    &--last {
      margin-top: 4px;
      padding-top: 6px;
      border-top: 1px dashed #e9e9e9;
    }
    &--active {
      font-weight: 600;
      .price-grids__range::before {
        content: "▸ ";
      }
    }
  }
  &__range {
    font-weight: 400;
    margin: 0;
  }
  &__value {
    margin: 0;
    white-space: nowrap;
  }
  &__empty {
    color: #9a9a9a;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/PriceGrids.vue